<template>
    <TableBodyRow>
        <TableBodyRowCell>
            <span
                class="text-xs cursor-pointer hover:underline"
                @click="isDrawerOpen = true"
            >
                {{ job.id }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.jobKey }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.queueName }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.releasesCounter }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.retriesCounter }}
            </span>
        </TableBodyRowCell>
        <TableBodyRowCell>
            <span class="text-xs">
                {{ job.executeAfterTimestamp }}
            </span>
        </TableBodyRowCell>
    </TableBodyRow>

    <Drawer
        :show="isDrawerOpen"
        @close="isDrawerOpen = false"
    >
        <template #content>
            <div class="space-y-4">
                <div>
                    <span class="font-semibold"> Payload </span>
                    <pre
                        class="max-h-80 text-xs overflow-auto p-4 border border-stone-300 rounded-lg"
                    >
                        {{ job.payload }}
                    </pre>
                </div>
                <div>
                    <span class="font-semibold"> Tags </span>
                    <pre
                        class="max-h-80 text-xs overflow-auto p-4 border border-stone-300 rounded-lg"
                    >
                        {{ job.tags }}
                    </pre>
                </div>
            </div>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import type { PendingQueueJobData } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        job: {
            type: Object as PropType<PendingQueueJobData>,
            required: true,
        },
    })

    const isDrawerOpen = ref(false)
</script>
